// src/components/LoadingScreen.js
// Écran de chargement élégant avec logo et spinner
import React from 'react'
import { useTranslation } from 'react-i18next'
import './LoadingScreen.css'

const LoadingScreen = ({ message }) => {
  const { t } = useTranslation()
  const text = message || t('common:loading')
  return (
    <div className="loading-screen">
      <div className="loading-content">
        {/* Logo Terrilink */}
        <div className="loading-logo-container">
          <img
            src="/icons/terrilink-192x192.png"
            alt="Terrilink"
            className="loading-logo"
          />
        </div>

        {/* Spinner stylé */}
        <div className="loading-spinner-container">
          <div className="loading-spinner">
            <div className="spinner-ring"></div>
            <div className="spinner-ring"></div>
            <div className="spinner-ring"></div>
          </div>
        </div>

        {/* Message optionnel */}
        {text && (
          <p className="loading-message">{text}</p>
        )}
      </div>
    </div>
  )
}

export default LoadingScreen
